/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8 8L14.7451 1.25489C14.9083 1.09169 15.1297 1 15.3605 1V1C16.61 1 17.4525 2.27761 16.9602 3.42611L15.9558 5.76973C15.6367 6.5144 15.4771 6.88674 15.5341 7.18671C15.584 7.44893 15.7366 7.68034 15.9579 7.82943C16.2112 8 16.6163 8 17.4265 8H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 19C6 19 7 21 9 21C10.1399 21 13.8785 21 16.8832 21C18.3439 21 19.0742 21 19.6644 20.7326C20.1846 20.4969 20.6267 20.1176 20.9388 19.6393C21.2928 19.0966 21.4039 18.3744 21.6262 16.9299L22.1637 13.436C22.4434 11.6181 22.5832 10.7091 22.3304 9.99674C22.0814 9.29502 21.5804 8.71097 20.9247 8.35816C20.259 8 19.3394 8 17.5 8V8H17M6 10L8 8M2 19L2 10C2 8.89543 2.89543 8 4 8V8C5.10457 8 6 8.89543 6 10V19C6 20.1046 5.10457 21 4 21V21C2.89543 21 2 20.1046 2 19Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M15.9533 5.77568L16.9602 3.42611C17.4525 2.27761 16.61 1 15.3605 1C15.1297 1 14.9083 1.09169 14.7451 1.25489L6 10V19C6 19 7 21 9 21H16.8832C18.3439 21 19.0742 21 19.6644 20.7326C20.1846 20.4969 20.6267 20.1176 20.9388 19.6393C21.2928 19.0966 21.4039 18.3744 21.6262 16.9299L22.1515 13.5151C22.4425 11.6237 22.588 10.6779 22.3101 9.94119C22.0617 9.28262 21.5896 8.73237 20.9765 8.3867C20.2906 8 19.3337 8 17.42 8C16.6157 8 16.2135 8 15.9614 7.83178C15.737 7.68199 15.5826 7.44787 15.5333 7.18257C15.478 6.88462 15.6364 6.51497 15.9533 5.77568Z"
				fill="currentColor"
			/>
			<path
				d="M6 19C6 19 7 21 9 21C10.1399 21 13.8785 21 16.8832 21C18.3439 21 19.0742 21 19.6644 20.7326C20.1846 20.4969 20.6267 20.1176 20.9388 19.6393C21.2928 19.0966 21.4039 18.3744 21.6262 16.9299L22.1515 13.5151C22.4425 11.6237 22.588 10.6779 22.3101 9.94119C22.0617 9.28262 21.5896 8.73237 20.9765 8.3867C20.2906 8 19.3337 8 17.42 8V8C16.6157 8 16.2135 8 15.9614 7.83178C15.737 7.68199 15.5826 7.44787 15.5333 7.18257C15.478 6.88462 15.6364 6.51497 15.9533 5.77568L16.9602 3.42611C17.4525 2.27761 16.61 1 15.3605 1V1C15.1297 1 14.9083 1.09169 14.7451 1.25489L6 10M2 19L2 10C2 8.89543 2.89543 8 4 8V8C5.10457 8 6 8.89543 6 10V19C6 20.1046 5.10457 21 4 21V21C2.89543 21 2 20.1046 2 19Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M15.2238 0.25C14.8816 0.25 14.5534 0.385943 14.3114 0.627922L9.06178 5.87756C8.02407 6.91527 7.50521 7.43413 7.13416 8.03963C6.80519 8.57646 6.56276 9.16173 6.41578 9.77395C6.25 10.4645 6.25 11.1982 6.25 12.6658V16.95C6.25 18.6302 6.25 19.4702 6.57698 20.112C6.8646 20.6765 7.32354 21.1354 7.88803 21.423C8.52976 21.75 9.36984 21.75 11.05 21.75H17.5254C18.9869 21.75 19.7177 21.75 20.3079 21.4826C20.828 21.2469 21.2701 20.8676 21.5822 20.3893C21.9363 19.8466 22.0474 19.1244 22.2696 17.6799L22.8623 13.8272C23.1398 12.0238 23.2785 11.1221 23.1192 10.3945C22.8319 9.08212 21.9049 8.00162 20.6515 7.51807C19.9566 7.25 19.0443 7.25 17.2197 7.25H16.9836C16.9059 7.25 16.867 7.25 16.8385 7.24672C16.5294 7.21116 16.3275 6.90496 16.4166 6.60686C16.4248 6.57939 16.4401 6.54367 16.4707 6.47222L17.5958 3.84717C18.3256 2.1443 17.0765 0.25 15.2238 0.25Z"
				fill="currentColor"
			/>
			<path
				d="M5 9.875C5 8.83947 4.16053 8 3.125 8C2.08947 8 1.25 8.83947 1.25 9.875V19.8748C1.25 20.9103 2.08947 21.7498 3.125 21.7498C4.16053 21.7498 5 20.9103 5 19.8748V9.875Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M6 19C6 19 7 21 9 21C10.1399 21 13.8785 21 16.8832 21C18.3439 21 19.0742 21 19.6644 20.7326C20.1846 20.4969 20.6267 20.1176 20.9388 19.6393C21.2928 19.0966 21.4039 18.3744 21.6262 16.9299L22.1515 13.5151C22.4425 11.6237 22.588 10.6779 22.3101 9.94119C22.0617 9.28262 21.5896 8.73237 20.9765 8.3867C20.2906 8 19.3337 8 17.42 8V8C16.6157 8 16.2135 8 15.9614 7.83178C15.737 7.68199 15.5826 7.44787 15.5333 7.18257C15.478 6.88462 15.6364 6.51497 15.9533 5.77568L16.9602 3.42611C17.4525 2.27761 16.61 1 15.3605 1V1C15.1297 1 14.9083 1.09169 14.7451 1.25489L8.5 7.5M6 17V19C6 20.1046 5.10457 21 4 21V21C2.89543 21 2 20.1046 2 19L2 10C2 8.89543 2.89543 8 4 8V8C5.10457 8 6 8.89543 6 10V13.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 19C6 19 7 21 9 21C10.1399 21 13.8785 21 16.8832 21C18.3439 21 19.0742 21 19.6644 20.7326C20.1846 20.4969 20.6267 20.1176 20.9388 19.6393C21.2928 19.0966 21.4039 18.3744 21.6262 16.9299L22.1515 13.5151C22.4425 11.6237 22.588 10.6779 22.3101 9.94119C22.0617 9.28262 21.5896 8.73237 20.9765 8.3867C20.2906 8 19.3337 8 17.42 8V8C16.6157 8 16.2135 8 15.9614 7.83178C15.737 7.68199 15.5826 7.44787 15.5333 7.18257C15.478 6.88462 15.6364 6.51497 15.9533 5.77568L16.9602 3.42611C17.4525 2.27761 16.61 1 15.3605 1V1C15.1297 1 14.9083 1.09169 14.7451 1.25489L6 10M2 19L2 10C2 8.89543 2.89543 8 4 8V8C5.10457 8 6 8.89543 6 10V19C6 20.1046 5.10457 21 4 21V21C2.89543 21 2 20.1046 2 19Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M15.2238 0.25C14.8816 0.25 14.5534 0.385943 14.3114 0.627922L9.06177 5.87756C8.02406 6.91527 7.50521 7.43413 7.13416 8.03963C6.80519 8.57646 6.56276 9.16173 6.41578 9.77395C6.25 10.4645 6.25 11.1982 6.25 12.6658V16.95C6.25 18.6302 6.25 19.4702 6.57698 20.112C6.8646 20.6765 7.32354 21.1354 7.88803 21.423C8.52976 21.75 9.36984 21.75 11.05 21.75H17.5254C18.9869 21.75 19.7177 21.75 20.3079 21.4826C20.828 21.2469 21.2701 20.8676 21.5822 20.3893C21.9363 19.8466 22.0474 19.1244 22.2696 17.6799L22.8623 13.8272C23.1398 12.0238 23.2785 11.1221 23.1192 10.3945C22.8319 9.08212 21.9049 8.00162 20.6515 7.51807C19.9566 7.25 19.0443 7.25 17.2197 7.25H16.9836C16.9059 7.25 16.867 7.25 16.8385 7.24672C16.5294 7.21116 16.3275 6.90496 16.4166 6.60686C16.4248 6.57939 16.4401 6.54367 16.4707 6.47222L17.5958 3.84717C18.3256 2.1443 17.0765 0.25 15.2238 0.25Z"
				fill="currentColor"
			/>
			<path
				d="M5 9.875C5 8.83947 4.16053 8 3.125 8C2.08947 8 1.25 8.83947 1.25 9.875V19.8748C1.25 20.9103 2.08947 21.7498 3.125 21.7498C4.16053 21.7498 5 20.9103 5 19.8748V9.875Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
